import { Component, OnInit, inject } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { AuthenticationService, PerformMfaResult } from '../../../core/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-confirm-mfa',
    templateUrl: './confirm-mfa.component.html',
    styleUrls: ['./confirm-mfa.component.scss'],
    imports: [FormsModule]
})
export class ConfirmMfaComponent implements OnInit {
  private authenticationService = inject(AuthenticationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  securityCode: string = null;
  error = false;

  username = '';
  session = '';
  destination = '';

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;

    this.username = queryParams['username'];
    this.session = queryParams['session'];
    this.destination = queryParams['destination'];

    if (!(this.username && this.session && this.destination)) {
      this.router.navigate(['/login'], { replaceUrl: true });
    } else {
      document.getElementById('securityCode').focus();
    }
  }

  onSubmit(confirmMfaForm: NgForm) {
    if (confirmMfaForm.valid) {
      this.authenticationService.performMfa(this.username, this.session, this.securityCode).subscribe(
        (result: PerformMfaResult) => {
          this.error = result !== PerformMfaResult.Succeeded;
        },
        (_err: HttpErrorResponse) => {
          this.error = true;
        }
      );
    }
  }
}
